export default __webpack_public_path__ + "static/blob10-1d1c7d9dd3ad6013fcc551a1025e8d44.svg";